module.exports = __webpack_public_path__ + "static/media/reservation_guest.c748e5f0.png";